<template>
  <div data-grm-comp="RoomCBTView" class="h-full relative">
    <div class="h-full bg-white flex">
      <div class="min-w-0 flex-1">
        <div class="h-full flex relative">
          <div class="w-full h-full p-4 flex flex-col overflow-y-auto lg:p-8">
            <div class="flex justify-between">
              <div class="flex flex-col gap-y-2">
                <p class="w-max rounded-xl text-sm text-blue-400 leading-6 font-bold">{{ $t("exam.question.title") }}</p>
                <p class="text-xl font-bold">{{ roomCBT.cbtTitle }}</p>
              </div>
              <div class="flex flex-col gap-y-2">
                <div class="flex flex-col gap-x-2">
                  <p class="w-max rounded-xl text-sm text-blue-400 leading-6 font-bold">{{ $t("exam.question.number") }}</p>
                  <p class="text-sm break-words">{{ roomCBT.questionList?.length }}개</p>
                </div>
              </div>
            </div>
            <div class="min-w-0 flex-1">
              <component
                v-for="(question, i) in roomCBT.questionList"
                :is="'RoomCBTQuestionChoice'"
                :key="question.questionId"
                :index="i"
                :question="question"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

import RoomCBTQuestionChoice from "@/components/Room/CBT/RoomCBTQuestionChoice.vue";

export default {
  name: 'RoomCBTView',
  components: {
    RoomCBTQuestionChoice,
  },
  computed: {
    ...mapState('cbt', [
      'roomCBT',
    ]),
  },
}
</script>